<template>
  <div class="products-category">
    <div class="products-category__header" v-if="items.length">
      <h2 class="products-category__title">{{content.Name}}</h2>
    </div>
    <div class="products-category__content" v-if="items.length">
      <ul class="product-list">
        <products-list-item v-for="item in items" :category="content.Id" :product="item" track-by="$index"></products-list-item>
      </ul>
    </div>
  </div>
</template>

<script>
import ProductsListItem from "./ProductsListItem";

export default {
  props: ["content", "productfilter"],
  components: {
    ProductsListItem
  },
  computed: {
    items: function () {
      var _productFilter = this.productfilter;
      if (_productFilter) {
        return this.content.Items.filter(function (item) {
          return item.Name.toLowerCase().indexOf(_productFilter.toLowerCase()) > -1;
        });
      } else {
        return this.content.Items;
      }
    }
  }
};
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .products-category{
    display: block;
    background: $brown_light;
    margin-bottom: 50px;

    &__header{
      @include clear-fix;
      background: $green_light;
      padding: 21px 50px 15px;
    }

    &__title{
      font-weight: normal;
      font-size: 36px;
      margin: 0;
      line-height: 34px;
    }

    &__content{
      padding: 40px 50px;
    }
  }

  .product-list{
    list-style: none;
    margin: 0;
    padding: 0;
    column-count: 3;
    line-height: 32px;
  }
</style>



// WEBPACK FOOTER //
// ProductsListCategory.vue?0e01eb5c